<style lang="scss" scoped>
  .lead-stage {
    ::v-deep .editable-modal {
      left: 72px !important;
      padding: 16px 24px 24px;

      select.form-control {
        min-width: 275px;
      }
    }
    ::v-deep .popper__arrow {
      left: 0px !important;
      position: relative;
      bottom: -30px;
      margin: 0px;
    }

    ::v-deep .popper[x-placement^="top"] .popper__arrow {
      bottom: -14px;
    }

    ::v-deep .popper[x-placement^="bottom"] .popper__arrow {
      top: -120px;
    }
  }
</style>

<template>
  <div class="lead-stage">
    <InputEditable
      type="select"
      field="stage_id"
      title="Estágio do funil"
      placeholder="Selecione"
      :value="stage"
      :options="getStages()"
      :url="'/lead/' + lead.hashid"
      :custom-class="customClass"
      @update="update"
      v-if="lead.stage && this.hasOpenDeals()"
    />

    <span
      :class="'editable-click pointer ' + customClass"
      @click="toggleCreateDealButton()"
      v-else
    >
      {{ lead.stage ? lead.stage.name : 'Lead' }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    lead: {
      type: Object,
      required: true,
    },
    customClass: '',
  },

  mounted () {
    Bus.$on('stagesRetrieved', (stages) => {
      this.stages = stages;
    });
  },

  data () {
    return {
      stages: [],
      stage: this.lead.stage.name || 'Selecione',
    };
  },

  methods: {
    hasOpenDeals () {
      return this.lead.deals.filter((deal) => deal.status === 'open').length > 0;
    },

    getStages () {
      return this.stages.map((stage) => ({ value: stage.id, text: stage.name }));
    },

    toggleCreateDealButton () {
      Bus.$emit('createDealButtonToggled', this.lead);
    },

    update (stage_id) {
      const stage = this.stages.find((stage) => stage.id == stage_id);

      this.stage = stage.name;
    },
  },
};
</script>
